import CoverableDetailsTemplate from '../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../templates/WizardPagetemplate';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../recoil/selectors/getOnsaCurrentProductSelector';
import { getOnsaCoverable } from '../../../utils/coverablesUtil';
import { useUpdateCoverableInformation } from '../../../recoil/hooks/useUpdateCoverableInformation';
import { useSaveClaimsHistoryInformation } from '../../../hooks/useSaveClaimsHistoryInformation';
import type { ClaimsHistoryInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import {
    type PrhHolidayHomeOnsaDTO,
    type PrhHouseOnsaDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/house';
import PrhClaimType from './PrhClaimType';
import { track } from '../../../utils/trackingUtil';
const PrhTypeOfClaimAndClaimAmountStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const { saveClaimsHistoryInformation } = useSaveClaimsHistoryInformation();
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { flavourName, fixedId } = currentProduct;
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId) as
        | PrhHouseOnsaDTO
        | PrhHolidayHomeOnsaDTO;
    const numberOfClaims = coverable.numberOfClaims ?? 0;
    const {
        topdanmarkClaimTypeCode = new Array(numberOfClaims).fill(''),
        claimValue = new Array(numberOfClaims).fill(0)
    } = coverable;

    const [claimType, setClaimType] = useState<string[]>(topdanmarkClaimTypeCode);
    const [compensations, setCompensations] = useState<number[]>(claimValue);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const otherClaimsNumber = claimType.filter(
        (type) => type === 'Anden skade' || type === 'Pipe'
    ).length;
    const isFormValid =
        claimType.every((type) => type !== '') &&
        (compensations.every((compensation) => compensation > 0) ||
            compensations.filter((compensation) => compensation === 0).length ===
                otherClaimsNumber);

    const convertCompensationValue = (): number[] => {
        const values = compensations.map((compensation) => {
            if (compensation === 1) return 35000;
            if (compensation === 2) return 185000;
            if (compensation === 3) return 400000;
            return 0;
        });
        return values;
    };

    const onNext = (): void => {
        setIsLoading(true);
        const valueOfClaim = convertCompensationValue();
        setCompensations(valueOfClaim);

        updateCoverableInformation({
            claimValue: valueOfClaim,
            topdanmarkClaimTypeCode: claimType
        });

        const updatedCoverable: ClaimsHistoryInformationToUpdateDTO = {
            [flavourName === 'Husforsikring' ? 'house' : 'holidayHome']: {
                fixedId: coverable.fixedId,
                numberOfClaims: coverable.numberOfClaims,
                topdanmarkClaimTypeCode: claimType,
                claimValue: valueOfClaim
            },
            productToUpdate: flavourName
        };
        const trackClaims = valueOfClaim
            .map((v): Record<string, string | number> => {
                return { claimValue: v };
            })
            .concat(
                claimType.map((t): Record<string, string | number> => {
                    return { topdanmarkClaimTypeCode: t };
                })
            );
        void saveClaimsHistoryInformation(updatedCoverable).then(() => {
            const houseFlavour = flavourName === 'Husforsikring' ? 'house' : 'holidayHome';
            track(`${houseFlavour}CoverableInformationTypeOfClaims`, trackClaims);
            setIsLoading(false);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onPrevious={goPrevious}
            onNext={onNext}
            disableNext={!isFormValid || isLoading}
            disablePrevious={isLoading}
        >
            <CoverableDetailsTemplate>
                <div>
                    {Array(numberOfClaims)
                        .fill(true)
                        .map((_, i) => (
                            <PrhClaimType
                                key={i}
                                index={i}
                                claimTypes={claimType}
                                setClaimTypes={setClaimType}
                                setCompensations={setCompensations}
                            />
                        ))}
                </div>
            </CoverableDetailsTemplate>
        </WizardPagetemplate>
    );
};

export default PrhTypeOfClaimAndClaimAmountStep;
